/** @jsx jsx */
import React, { Fragment, useContext, useState, useEffect } from "react";
import { Global, css } from "@emotion/react"
import { Helmet } from "react-helmet";
import { SearchContext } from "@/context/search-context";
import { MenuContext } from "@/context/menu-context";
import SearchPopup from "@/components/search-popup";
import PopupMenu from "@/components/popup-menu";
import { Link as ScrollLink } from "react-scroll";
import { jsx } from '@emotion/react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import ImgMore from '../assets/images/lp/icons/more.svg'


// import "typeface-oswald";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/css/animate.css";
import "@/css/font-awesome.min.css";
import "@/css/icons.css";
// import "@/css/preset.css";
// import "@/css/theme.css";
// import "@/css/responsive.css";

import { showIt }  from '../assets/styles/layout.styles'

const GlobalStyles = () => {
  return (
    <Global styles={css`
        @import url("https://use.typekit.net/wxt5lxj.css");
        @import url("https://use.typekit.net/zox8ylt.css");
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
        body, html{
            margin: 0;
            padding: 0;
            scroll-behavior: smooth;
        }
        body{
            line-height: 32px;
            color: #818181;
            letter-spacing: 0.64px;
            font-size: 16px;
            font-family: "normalidad-variable", sans-serif;
            transition: all ease 400ms;
            -webkit-transition: all ease 400ms;
            -moz-transition: all ease 400ms;
            /* width */
          ::-webkit-scrollbar {
            width: 9px;
          }
          /* Track */
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
          }

          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #00854E;
          }

          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #4BE66A;
            opacity:0.2;
          }
        }

        /*------------------------------------------------------------------------------
        / 2. Typography Settings
        ------------------------------------------------------------------------------*/
        h1, h2, h3, h4, h5 h6{
            color: #000000;
            margin: 0 0 15px;
        }
        a{
            color: #000;
            text-decoration: none;
            transition: all ease 700ms;
            -webkit-transition: all ease 700ms;
            -moz-transition: all ease 700ms;
        }
        a:hover, a:focus{
            text-decoration: none;
            outline: 0;
        }
        a:focus{
            color: #fff;
        }
        ul li{
            margin: 0;
            padding: 0;
            list-style: none;
        }  

        @media(min-width: 1200px) {
            .container {
                max-width: 1200px;
            }
        }
        .accordion {
          border: none !important;
        }
        .accordion__button {
          font-family: "normalidad-variable", sans-serif;
          background-color: #ffffff !important;
          font-weight: 7600;
          font-size: 32px !important;
          line-height: 120%;
          display: flex;
          align-items: center;
          color: #312E2D;
          font-variation-settings: "wght" 130, "wght" 600;
        }
        .accordion__button::before {
          display: none !important;
        }
        .accordion__button::after {
          display: inline-block;
          content: '';
          height: 10px;
          width: 10px;
          margin-right: 12px;
          border-bottom: 2px solid currentColor;
          border-right: 2px solid currentColor;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          margin-left: auto;
        }
        .accordion__button[aria-expanded='true']::after, .accordion__button[aria-selected='true']::after {
          -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        .scroll-to-top {
          background: #F7FF53;
          color:rgb(0, 131, 4);
        }
        a[data-hs-anchor="true"] {   
          display: block; 
          position: relative; 
          visibility: hidden; 
          top: 0px;  
          }
    `} />
  )
}

const Layout = ({ PageTitle, children }) => {
  const { searchStatus } = useContext(SearchContext);
  const { menuStatus } = useContext(MenuContext);
  const [scrollTop, setScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({
      duration : 1000,
      once:true
    });
    AOS.refresh();
  }, []);

  const handleScrollTop = () => {
    if (window.scrollY > 70) {
      setScrollTop(true);
    } else if (window.scrollY < 70) {
      setScrollTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScrollTop);
    return () => {
      window.removeEventListener("scroll", handleScrollTop);
    };
  }, [scrollTop]);

  return (
    <Fragment>
      <Helmet>
        <title>
          {PageTitle} - A escola do ser íntegro, inteligente e conectado.
        </title>
        <link rel="stylesheet" href="https://use.typekit.net/wxt5lxj.css" />
        <script type="text/javascript" async src="https://d335luupugsy2.cloudfront.net/js/loader-scripts/f350d3ac-8229-4dc2-bf6b-8eeb4ece77d5-loader.js" />
      </Helmet>
      <div id="wrapper">
      <GlobalStyles />
        {children}</div>
      {true === searchStatus ? <SearchPopup /> : null}
      {true === menuStatus ? <PopupMenu /> : null}

      {scrollTop === true ? (
        <ScrollLink
            css={showIt}
          to="wrapper"
          smooth={true}
          duration={500}
          id="backToTop"
          className="scroll-to-top"
        >
          <i className="fa fa-angle-double-up"></i>
        </ScrollLink>
      ) : null}
    </Fragment>
  );
};

export default Layout;
